import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { USER } from "constants/AuthConstant";
import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";

export const changePaymentStatus = createAsyncThunk("changePaymentStatus", async ({ id, status, data }, { rejectWithValue }) => {
	try {
		const user = PermissionManager.getItem(USER)?.user;
		const channel_id = user?.user_channel?.[0]?.channel_uuid;
		if (!channel_id) throw new Error("Channel ID not found");
		const response = await axiosHttp.patch(`channel/${channel_id}/payment/request/${id}/${status}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PaymentStatusChangeSlice = createSlice({
	name: "PaymentStatusChangeSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(changePaymentStatus.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(changePaymentStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(changePaymentStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default PaymentStatusChangeSlice.reducer;
